module.exports = __webpack_public_path__ + "static/img/65271357_p1_master1200.f863a07.jpg";